import {
    useEffect,
    useRef,
    useState
} from 'react'
import { useDialogContext } from '@shared/hooks/dialogContext'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import CropperCanvas from 'react-cropper'

export default function Cropper() {
    const {
        form: {
            setValue,
            watch
        },
        toCrop,
        urls,
        viewFields,
    } = useDialogContext()
    const images = watch('images')

    const ref = useRef()
    const [cropLoading, setCropLoading] = useState(false)

    useEffect(() => {
        if(!toCrop) return
        const img = new Image()
        setCropLoading(true)
        img.onload = () => {
            setCropLoading(false)
        }
        img.src = toCrop
    }, [toCrop])

    const crop = () => {
        const canvas = ref.current.cropper.getCroppedCanvas()

        canvas.toBlob((blob) => {
            const url = URL.createObjectURL(blob)
            urls.current = [...urls.current, url]

            setValue('images', images.map((img) => {
                if ((img?.url || img.image) !== toCrop) return img
                if (img.url) URL.revokeObjectURL(img.url)

                const fileName = Date.now().toString(36) + Math.random().toString(36).slice(2, 6) + '.jpeg'
                return {
                    ...img,
                    url,
                    file: new File([blob], fileName, { type: 'image/jpeg' }),
                }
            }), { shouldDirty: true })

            viewFields()
        }, 'image/jpeg', 0.95)
    }

    return (
        <>
            <DialogTitle>قص الصورة</DialogTitle>
            <DialogContent>
                <div style={{height: '100%'}}>
                    {cropLoading
                        ? <Box className='centerized'>
                            <CircularProgress />
                        </Box>
                        : <CropperCanvas
                                src={toCrop}
                                ref={ref}
                                style={{
                                    width: '100%',
                                    height: 'inherit'
                                }}
                                viewMode={1}
                                guides={false}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                            />
                    }
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant='text' onClick={viewFields}>رجوع</Button>
                <Button variant='text' onClick={crop}>قص</Button>
            </DialogActions>
        </>
    )
}